<div class="wrapper">

    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Assessments & Forms</h1>
        </div>
        <div class="content-section">
            <div class="main-block-innner">
                <div class="add-store-block input-style mw-100">
                    <div class="form-user">
                        <div class="card">
                            <div class="card-body">



                                <!-- Edit questtionnaire form start here  -->

                                <form [formGroup]="editquesionform">
                                    <ul class="form-group row px-3" formArrayName="QueArr1">
                                        <li class="d-flex">
                                            <label class="card-title col-md-3 text-nowrap">
                                                Title :
                                            </label>
                                            <h6 class="m-0"> {{programTitle}}</h6>
                                            <!-- <input type="text" name="" value="Program Questionnaire"
                                            placeholder="Add Title" class="form-control col-md-9" id=""> -->
                                        </li>
                                        @for (question of editquesionform?.controls.QueArr1['controls']; track
                                        question;let i = $index) {
                                        <div class="row p-3 border w-100 mt-3 mb-3" formGroupName="{{i}}">
                                            <li class="py-2 d-flex">
                                                <span (click)="addUser1('',i)" class="d-flex w-100">
                                                    <label class="addQuestion active">Add New Question</label>
                                                    <i class="fa fa-plus addPlus ms-3"></i>
                                                </span>
                                                <div class="col-md-6 position-absolute quedrop">
                                                    <select name="" id="" class="custom-select col-md-10"
                                                        formControlName="QuestionType">
                                                        <option value="">Select question type</option>
                                                        <option value="YESNO">MCQ(radio type question)
                                                        </option>
                                                        <option value="checkbox">Multiple type question
                                                        </option>
                                                        <option value="text">Input type question</option>
                                                    </select>
                                                </div>
                                            </li>
                                            <li class="py-2 d-flex">
                                                <span class="me-2"> Q{{i+1}}.</span>
                                                <div style="flex: 1">
                                                    <input type="text" name=""
                                                        placeholder="Type your question in english"
                                                        formControlName="QuestionText" class="form-control" id="">
                                                    <br />
                                                    <input type="text" name=""
                                                        placeholder="Type your question in français"
                                                        formControlName="QuestionTextFR" class="form-control" id="">
                                                    <br />
                                                    <input type="text" name=""
                                                        placeholder="Type your question in español"
                                                        formControlName="QuestionTextES" class="form-control" id="">
                                                </div>
                                                @if(editquesionform?.controls.QueArr1['controls'].length > 1){
                                                <i (click)="deleteUser1(i)" class="fa fa-times addPlus ms-3"
                                                    aria-hidden="true"></i>
                                                }
                                            </li>
                                            <div></div>
                                            @if(question.value.QuestionType == 'checkbox' || question.value.QuestionType
                                            == 'YESNO'){
                                            <li class="py-2 d-flex align-items-center">
                                                <span>Options</span>
                                            </li>
                                            }

                                            @if(question.value.QuestionType == 'checkbox' || question.value.QuestionType
                                            == 'YESNO'){
                                            <li formArrayName="options">
                                                <div>
                                                    @if(question.value.QuestionType == 'checkbox'){
                                                    <div>
                                                        @for (options of question.controls.options.controls; track
                                                        options;let j = $index) {
                                                        <div class=" my-2" formGroupName="{{j}}">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <input type="text" name="" placeholder="option"
                                                                        formControlName="option"
                                                                        style="max-width: 100%;"
                                                                        class="form-control col-md-4 ms-3" id="">
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <input type="text" name="" placeholder="option"
                                                                        formControlName="optionFR"
                                                                        style="max-width: 100%;"
                                                                        class="form-control col-md-4 ms-3" id="">
                                                                </div>
                                                                <div class="col-md-4 align-items-center d-flex">
                                                                    <input type="text" name="" placeholder="option"
                                                                        formControlName="optionES"
                                                                        style="max-width: 100%; flex: 1"
                                                                        class="form-control col-md-4 ms-3" id="">
                                                                    @if(question.controls.options.controls.length < 4){
                                                                        <i class="fa fa-plus addPlus ms-3"
                                                                        (click)="addOption1(i)"></i>
                                                                        }
                                                                        @if(question.controls.options.controls.length >
                                                                        1){
                                                                        <i (click)="deleteOption1(i,j)"
                                                                            class="fa fa-times addPlus ms-3"
                                                                            aria-hidden="true"></i>
                                                                        }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>
                                                    }
                                                    @if(question.value.QuestionType == 'YESNO'){
                                                    <div class="d-flex align-items-center">
                                                        <div class="d-flex align-items-center">
                                                            <input type="radio" name="typeRadio" id="" disabled>
                                                            <label class="ms-2"> Yes </label>
                                                        </div>
                                                        <div class="d-flex align-items-center">
                                                            <input type="radio" name="typeRadio" disabled class="ms-3"
                                                                id="">
                                                            <label class="ms-2"> No </label>
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                            </li>
                                            }
                                        </div>
                                        }
                                        <li class="my-3 d-flex justify-content-center">

                                            <button class="btn btn-theme" type="submit"
                                                (click)="editQuestionnaireApi()">Save</button>

                                            <button class="btn btn-danger ms-3" style="min-width: 100px;"
                                                routerLink="/assessment">
                                                Back
                                            </button>
                                        </li>
                                    </ul>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>